export const ANALYTICS_EVENT = {
  USER_INFO: "user_info",
  PAGE_VIEW: "page_view",
  USER_INTERACTION: "user_interaction",
  SET_GLOBAL_PARAM: "set_session_param",
  UNSET_GLOBAL_PARAM: "unset_session_param",
};